import React, { FC, useEffect, useState, useContext } from 'react'
import Button from '../../../button/Button'
import styles from './show-area-codes.module.scss'
import { IState } from 'src/Interface'
import { StateContext } from 'src/AppContext'

interface Props {
  updateList: (list) => void
  close: () => void
  isEditable?: boolean
  title: string
  areaCodes: any
}

const ShowAreaCodes: FC<Props> = ({ close, isEditable = false, areaCodes = [], updateList, title }: Props) => {
  const [list, setList] = useState(areaCodes)
  const [loading, setLoading] = useState(false)
  const state: IState = useContext(StateContext)

  const update = (value) => {
    const values = [...list]
    const index = list.findIndex((v: any) => v.nr === value.nr)
    values.splice(index, 1)
    setList(values)
  }

  useEffect(() => {
    if (state.coordinates && state.coordinates.length) {
      setList(
        state.coordinates.filter(
          coordinate => areaCodes.find(zipCode => coordinate.nr === zipCode.toString()))
          .map(code => {
            return {
              navn: code.navn,
              nr: code.nr
            }
          }))
      setLoading(false)
    }
  }, [state.coordinates, areaCodes])


  const handleUpdate = () => {
    updateList(list)
    close()
  }


  return (
    <div className={`${styles.zipCodes}`}>
      <header className={styles.modalHeader}>
        {loading ? <div className='label-loading' /> : <h4 className={styles.modalTitle}>{title}</h4>}
        {isEditable && !loading && <button className={styles.clearAll} onClick={() => setList([])}>Fravælg alle</button>}
      </header>
      <div className={styles.modalContent}>
        {loading ?
          <ul>
            {new Array(10).fill(null).map((item, i) => <li key={i} className={styles.item} />)}
          </ul> :
          <ul>
            {
              list.map((item: any, i) => {
                return (
                  <li key={i} className={styles.item}>
                    <span>{item.navn ? item.navn : 'No name'}</span>
                    <span className='tw-ml-auto tw-opacity-50'>{item.nr || item.kode ? item.nr : item}</span>
                    {isEditable && <svg onClick={() => update(item)} xmlns="http://www.w3.org/2000/svg" className={`tw-h-5 tw-w-5 tw-opacity-50 tw-ml-4`} viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>}
                  </li>
                )
              }
              )}
          </ul>
        }
      </div>
      <footer className={styles.footer}>
        {!loading && <>
          <Button type='secondary' label='Annuller' handleClick={() => close()} />
          {isEditable && <Button type='primary' label='Gem ændringer' modifiers='tw-ml-auto' handleClick={handleUpdate} />}
        </>}
      </footer>
    </div >
  )
}

export default ShowAreaCodes